import tokens from '@kluein/design-tokens';
import { Box } from '@kluein/klue-ui';
import styled from 'styled-components';

export const DashboardSectionHeader = styled(Box).attrs({
  height: '60px',
  flex: { shrink: 0 },
  round: 'xsmall',
  border: { color: tokens.color.neutral.lightgrey.main, size: 'xsmall' },
  direction: 'row',
  align: 'center',
  justify: 'between',
  elevation: 'xsmall',
})`
  background: ${tokens.color.neutral.white.main};
`;
